import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'

export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  height: calc(100vh - 142px);
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  gap: 20px;
`
export const LeftArrowSpan = styled.span`
  cursor: pointer;
`
export const TopRoleSection = styled(Flex)`
  padding-top: 20px;
  padding-left: 20px;
  align-items: center;
  margin-bottom: 10px;
`

export const RoleSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.PRIMARY};
  padding-left: 15px;
  &:hover {
    cursor: pointer;
  }
`
export const JobDetailsSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.GREY_T_60};
  padding-left: 10px;
`
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const Name = styled.div`
  font-weight: 600;
  font-size: 18px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #1b1f22;
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
  @media only screen and (max-device-width: 767px) {
    font-size: 11px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    font-size: 11px;
    line-height: 18px;
  }
`
